<template>
    <div class="shadow-inner px-6 py-6 sm:py-16 min-h-screen">
        <div class="flex flex-wrap">
            <div class="w-full sm:w-2/6 sm:px-4 xl:px-16 mb-6">
                <div class="w-full bg-white rounded-lg shadow-sm py-4 px-4 xl:px-6 text-left cursor-pointer hover:bg-gray-100" @click="section = 'profile'">
                    <div class="w-full text-left">
                        <span :class="{'font-bold': section == 'profile'}">{{ $t("Profilo personale") }}</span>
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 block float-right text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                        </svg>
                    </div>
                </div>
                <div class="w-full bg-white rounded-t-lg shadow-sm py-4 px-4 xl:px-6 text-left cursor-pointer hover:bg-gray-100 mt-6" @click="section = 'projects'">
                    <div class="w-full text-left">
                        <span :class="{'font-bold': section == 'projects'}">{{ $t("I tuoi progetti") }}</span>
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 block float-right text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                        </svg>
                    </div>
                </div>
                <div class="w-full bg-white rounded-b-lg shadow-sm py-4 px-4 xl:px-6 text-left cursor-pointer hover:bg-gray-100 border-t border-gray-100" @click="section = 'partecipants'">
                    <div class="w-full text-left">
                        <span :class="{'font-bold': section == 'partecipants'}">{{ $t("Aggiungi partecipanti") }}</span>
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 block float-right text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                        </svg>
                    </div>
                </div>
                <div class="w-full bg-white rounded-b-lg shadow-sm py-4 px-4 xl:px-6 text-left cursor-pointer hover:bg-gray-100 border-t border-gray-100 mt-6" @click="logout()">
                    <div class="w-full text-left">
                        <span class="text-red-800">{{ $t("Logout") }}</span>
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 block float-right text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                        </svg>
                    </div>
                </div>
            </div>
            <div class="w-full sm:w-4/6" v-if="section == 'profile'">
                <div class="heading w-full text-left">
                    <h1 class="text-green-dark text-sm font-bold inline mr-1">{{ $t("Dashboard") }}</h1>/<h3 class="text-green-dark font-medium text-sm inline ml-1">{{ $t("Profilo personale") }}</h3>
                </div>
                <div class="w-full flex flex-wrap bg-white rounded-lg shadow-sm px-2 mt-4 sm:mt-8 py-10">
                    <div class="w-full sm:w-1/2 text-left px-6">
                        <label class="font-bold">{{ $t("Nome") }}</label>
                        <input type="text" v-model="user.name" class="bg-gray-100 rounded-lg w-full px-4 py-3" :class="{'border border-red-500': $v.user.name.$error}">
                        <span v-if="$v.user.name.$error" class="block text-red-500 text-xs">{{ $t("Required field") }}</span>
                    </div>
                    <div class="w-full sm:w-1/2 text-left px-6 mt-3 sm:mt-0">
                        <label class="font-bold">{{ $t("Cognome") }}</label>
                        <input type="text" v-model="user.surname" class="bg-gray-100 rounded-lg w-full px-4 py-3" :class="{'border border-red-500': $v.user.surname.$error}">
                        <span v-if="$v.user.surname.$error" class="block text-red-500 text-xs">{{ $t("Required field") }}</span>
                    </div>
                    <div class="w-full text-left px-6 mt-6">
                        <label class="font-bold">{{ $t("Il tuo indirizzo email") }}</label>
                        <input type="text" v-model="user.email" readonly class="bg-gray-100 rounded-lg w-full px-4 py-3">
                    </div>
                    <div class="w-full text-left px-6 mt-6">
                        <label class="font-bold">{{ $t("Numero di matricola universitaria") }}</label>
                        <input type="text" v-model="user.badge" class="bg-gray-100 rounded-lg w-full px-4 py-3" :class="{'border border-red-500': $v.user.badge.$error}">
                        <span v-if="$v.user.badge.$error" class="block text-red-500 text-xs">{{ $t("Required field") }}</span>
                    </div>
                    <div class="w-full px-6 mt-6 text-center">
                        <button @click="update()" class="rounded-full bg-green-light text-white px-6 py-3 font-semibold text-sm">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 inline-block mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4" />
                            </svg>
                            <span>{{ $t("Aggiorna dati personali") }}</span>
                            <loaderIco class="h-5 w-5 text-white ml-2" v-if="loading" />
                        </button>
                    </div>
                </div>
                
                <Docs :type="`identity`"  :sm="false" :title="$t(`Documento di identità`)" :text="$t(`Carica qui la tua carta di identità fronte e retro.`)" :name="`documento-identita`" maxDocs="2" />

                <Docs :type="`school`" :sm="false" :title="$t(`Documento universitario`)" :text="$t(`Carica qui un un documento attestante la tua iscrizione all’università tra: autocertificazione carriera ed esami, autocertificazione carriera, autocertificazione tasse.`)" :name="`documento-universita`" maxDocs="1" />
            </div>
            <div class="w-full sm:w-4/6" v-if="section == 'projects'">
                <div class="heading w-full text-left">
                    <h1 class="text-green-dark text-sm font-bold inline mr-1">{{ $t("Dashboard") }}</h1>/<h3 class="text-green-dark font-medium text-sm inline ml-1">{{ $t("I tuoi progetti") }}</h3>
                    <p class="text-sm mt-1">{{ $t("Tutti i progetti devono essere in formato pdf e non superare il limite di 60Mb") }}</p>
                    <p class="text-sm mt-1">{{ $t("I documenti possono essere ricaricati e/o modificati liberamente fino al 21/03/2022.") }}</p>
                </div>

                <Docs :type="`proj1`" :sm="true" :title="$t(`Carica relazione illustrativa e tecnica`)" :text="$t(`Illustrativa dei criteri guida anche attraverso schemi e immagini. Formato A3, massimo quindici facciate (copertina inclusa) per un totale di massimo 15.000 battute.`)" :name="`illustrazione-tecnica`" maxDocs="1" />

                <Docs :type="`proj2`" :sm="true" :title="$t(`Carica elaborato grafico n° 1`)" :text="$t(`In formato UNI A1 su file PDF/A orientato in senso orizzontale che illustri l’idea di progetto.`)" :name="`elaborato-grafico`" maxDocs="1" />

                <Docs :type="`proj3`" :sm="true" :title="$t(`Carica elaborato grafico n° 2`)" :text="$t(`In formato UNI A1 su file PDF/A orientato in senso orizzontale che illustri l’idea di progetto.`)" :name="`elaborato-grafico2`" maxDocs="1" />
           
            </div>
            <div class="w-full sm:w-4/6" v-if="section == 'partecipants'">
                <div class="heading w-full text-left">
                    <h1 class="text-green-dark text-sm font-bold inline mr-1">{{ $t("Dashboard") }}</h1>/<h3 class="text-green-dark text-sm inline ml-1 font-medium">{{ $t("Aggiungi partecipanti") }}</h3>
                    <p class="text-sm mt-1">{{ $t("E’ possibile partecipare al presente concorso in gruppo con numero massimo di 3 persone. Il sottoscrittore del presente account è responsabile dei membri aggiunti che devono essere anch’essi studenti regolarmente iscritti per l’anno accademico 2021/2022 a corsi di Laurea specialistica in Architettura, Urbanistica e Ingegneria delle Costruzioni presso gli Atenei Universitari locali, nazionali e internazionali.") }}</p>
                </div>
                <Partecipants/>
            </div>
        </div>
    </div>
</template>
<script>
import loaderIco from '@/svg/loader.vue'
import Docs  from '@/components/Docs'
import Partecipants  from '@/components/Partecipants'
import { required, minLength, email, sameAs } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'
import firebase from 'firebase/app'
import "@firebase/auth"
import { db } from '@/db'

export default {
    components: { Docs, Partecipants, loaderIco },
    data() {
        return {
            section: 'profile',
            loading: false
        }
    },
    mounted() {
        this.$v.$reset()
    },
    validations: {
        user: {
            name: {
                required,
            },
            surname: {
                required,
            },
            email: {
                required,
                email
            },
            badge: {
                required,
            }
        }
    },
    computed: {
        ...mapGetters(["user"])
    },
    methods: {
        async update() {
            this.$v.$touch()
            if (this.$v.$invalid) return false

            this.loading = true
            // store user locally
            this.$store.commit('SET_USER', this.user)
            // persist user additional data
            await db.collection('users').doc(this.user.id).update({
                name: this.user.name,
                surname: this.user.surname,
                badge: this.user.badge
            })
            this.loading = false        
        }
    }
}
</script>